<template>
  <div class="contents2">
    <!-- pc -->
    <img class="bg" src="static/img/service/bg_white.png" v-show="!isMobile" />
    <div class="contents" v-show="!isMobile">
      <div class="img">
        <img src="static/img/service/site_service_img_02.png" />
      </div>
      <div class="text">
        <div class="wrap">
          <div class="icon">
            <img src="static/img/icon_paper.png" />
          </div>
          <div class="title">외장수리 <span>비교 견적</span></div>
          <div class="body">
            <p>
              덴트, 범퍼 수리, 판금도색 등 외장 수리가 필요할 때<br />
              손상 부위의 사진 3장으로 내 주변 수리업체들의 견적서를<br />
              실시간으로 받아보세요.
            </p>
            <p>사전견적 확인, 견적 비교 후 수리, 1년 품질보증서 까지!</p>
          </div>
          <div class="btn">
            <a @click="gotoPage('https://www.carsuri.co.kr/intro?tab=2')"><img src="static/img/service/btn.png"/></a>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile -->
    <div class="contents" v-show="isMobile">
      <div class="img">
        <img src="static/img/mobile/service/site_service_img_02_m.png" />
      </div>
      <div class="text">
        <img src="static/img/mobile/service/background_gray_02.png" />
        <div class="wrap">
          <div class="icon">
            <img src="static/img/mobile/service/icon_paper.png" />
          </div>
          <div class="title">수리 <span>비교 견적</span></div>
          <div class="body">
            <p>
              덴트, 범퍼 수리, 판금도색 등<br />
              외장 수리가 필요할 때 손상 부위의 사진 3장으로<br />
              내 주변 수리업체들의 견적서를<br />
              실시간으로 받아보세요.
            </p>
            <p>
              사전견적 확인, 견적 비교 후 수리,<br />
              1년 품질보증서 까지!
            </p>
          </div>
          <div class="btn">
            <a @click="gotoPage('https://www.carsuri.co.kr/intro?tab=2')"><img src="static/img/mobile/service/btn.png"/></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    window.addEventListener('resize', this.resize)
    this.resize()
  },
  methods: {
    resize() {
      if (window.innerWidth > 640) {
        this.isMobile = false
      } else {
        this.isMobile = true
      }
    },
    gotoPage(path) {
      window.open(path)
    }
  }
}
</script>

<style scoped>
.contents2 {
  width: 100%;
  position: relative;
}
.contents2 .bg {
  width: 100%;
  height: auto;
  display: block;
}
/* pc */
@media (max-width: 1280px) {
  .contents2 .contents .icon img {
    width: 32px;
    height: auto;
  }
  .contents2 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 30px;
    line-height: 58px;
    color: #000000;
  }
  .contents2 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 58px;
    color: #000000;
  }
  .contents2 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
    color: #444444;
  }
  .contents2 .contents .btn img {
    width: 160px;
    height: auto;
  }
}
@media (min-width: 1280px) {
  .contents2 .contents .icon img {
    width: 2.5vw;
    height: auto;
  }
  .contents2 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 2.3vw;
    line-height: 4.4vw;
    color: #000000;
  }
  .contents2 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 2.3vw;
    line-height: 4.4vw;
    color: #000000;
  }
  .contents2 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 1.1vw;
    line-height: 1.9vw;
    color: #444444;
  }
  .contents2 .contents .btn img {
    width: 12vw;
    height: auto;
  }
}
@media (min-width: 641px) {
  .contents2 .contents {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }
  .contents2 .text {
    width: 50%;
    height: 100%;
    float: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .contents2 .img {
    width: 50%;
    height: 100%;
    float: left;
  }
  .contents2 .img img {
    width: 100%;
    height: 100%;
  }
  .contents2 .contents .body p {
    margin: 5% 0;
  }
  .contents2 .contents .btn {
    margin-top: 15%;
  }
  .contents2 .contents .btn a {
    cursor: pointer;
  }
}
/* mobile */
@media (max-width: 640px) {
  .contents2 .img {
    background: #f7f8fa;
  }
  .contents2 .img img {
    width: 100%;
    height: 100%;
  }
  .contents2 .text {
    width: 100%;
    height: 100%;
    position: relative;
  }
  .contents2 .text img {
    width: 100%;
    height: 100%;
  }
  .contents2 .text .wrap {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 0 0 0 5%;
    background: #f7f8fa;
  }
  .contents2 .contents .icon img {
    width: 8vw;
    height: auto;
  }
  .contents2 .contents .title {
    font-style: normal;
    font-weight: 300;
    font-size: 6.5vw;
    line-height: 8.5vw;
    color: #000000;
  }
  .contents2 .contents .title span {
    font-style: normal;
    font-weight: bold;
    font-size: 6.5vw;
    line-height: 8.5vw;
    color: #000000;
  }
  .contents2 .contents .body {
    font-style: normal;
    font-weight: 300;
    font-size: 4.3vw;
    line-height: 6.5vw;
    color: #444444;
  }
  .contents2 .contents .btn img {
    width: 50vw;
    height: auto;
  }
  .contents2 .contents .icon {
    margin-top: 15%;
    margin-bottom: 5%;
  }
  .contents2 .contents .body p {
    margin: 5% 0;
  }
  .contents2 .contents .btn {
    margin-top: 15%;
  }
  .contents2 .contents .btn a {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/service/Contents2.vue